module.exports = __webpack_public_path__ + "static/media/info.70323228.svg";